import { isMac } from 'core/helpers/browser';

type TModifier = 'Ctrl' | 'Alt' | 'Shift' | 'Meta' | 'CmdOrCtrl';
type TKey =
  | 'Escape'
  | 'Backspace'
  | 'Enter'
  | `F${number}`
  | 'ArrowDown'
  | 'Space'
  | 'ArrowLeft'
  | 'ArrowRight'
  | 'Equal'
  | `Digit${string}`
  | `Numpad${string}`;
export type TStrKeyBind = TKey | `${TModifier}+${TKey}`;

type TKKB = {
  ctrl: boolean;
  alt: boolean;
  shift: boolean;
  meta: boolean;
  key: string;
};

const genEmptyKkb = (): TKKB => ({
  ctrl: false,
  alt: false,
  shift: false,
  meta: false,
  key: 'none',
});

export const parseKkb = (template: TStrKeyBind): TKKB => {
  if (template.includes('-')) {
    throw new Error(`Do not use - in KKB, use +. KKB: ${template}`);
  }

  return template
    .toLowerCase()
    .replace(/\s+/, '')
    .split('+')
    .reduce((kkb, str) => {
      switch (str) {
        case 'cmdorctrl':
          kkb[isMac ? 'meta' : 'ctrl'] = true;
          break;

        case 'ctrl':
          kkb.ctrl = true;
          break;

        case 'shift':
          kkb.shift = true;
          break;

        case 'alt':
          kkb.alt = true;
          break;

        case 'meta':
          kkb.meta = true;
          break;

        default:
          kkb.key = str;
      }

      return kkb;
    }, genEmptyKkb());
};

export const checkKkb = (event: KeyboardEvent, kkb: TKKB): boolean => {
  return (
    event.ctrlKey === kkb.ctrl &&
    event.altKey === kkb.alt &&
    event.shiftKey === kkb.shift &&
    event.metaKey === kkb.meta &&
    event.code.toLowerCase() === kkb.key
  );
};
